import { PlusCircle, Menu } from 'lucide-react';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

interface HeaderProps {
  onToggleDrawer?: () => void;
}

function Header({ onToggleDrawer }: HeaderProps) {
  const navigate = useNavigate();
  const pathname = window.location.pathname;

  const isRentalPath = useMemo(() => {
    return pathname.includes('/rentals') || pathname === "/dashboard"
  }, [pathname]) ;

  const showAddButton = useMemo(() => {
    // Define the paths where the button should be shown
    const pathsWithButton = [
      "/dashboard",
      "/rentals",
      "/rentals/create-transaction",
      "/vehicles",
      '/vehicles/create-vehicle'
    ];
    
    // Check if the current pathname matches any of the defined paths
    return pathsWithButton.includes(pathname);
  }, [pathname]);

  const handleAddTransaction = () => {
    navigate(isRentalPath ? "rentals/create-transaction" : "/vehicles/create-vehicle");
  }
  return (
    <header className="flex justify-between items-center px-6 h-16 border-b border-gray-300">
      {/* Drawer toggle button for mobile */}
      {onToggleDrawer && (
        <Button
          onClick={onToggleDrawer}
          variant="ghost"
          className="md:hidden mr-2 border border-gray-200 shadow rounded-sm"
          aria-label="Open menu"
        >
          <Menu className="h-6 w-6" />
        </Button>
      )}
      <div className="flex-1 flex justify-end">
        {showAddButton && (
          <Button onClick={handleAddTransaction} variant="ghost" className="gap-2 rounded-sm border border-gray-200 shadow">
            <span className="font-semibold">
              Add new {isRentalPath ? 'transaction' : 'vehicle'}
            </span>
            <PlusCircle className="h-4 w-4" />
          </Button>
        )}
      </div>
    </header>
  );
}

export default Header